<template>
  <div class="langSelect">
    <select v-model="$root.$i18n.locale" @change="onChange">
      <option v-for="lang in langs" :key="lang.code" :value="lang.code">
        {{ lang.text }}
      </option>
    </select>
  </div>
</template>

<script>
import store from '../../store';

export default {
  name: 'LanguageDropdown',

  inheritAttrs: false,

  data: function() {
    return {
      langs: [
        { code: 'en', text: 'English' },
        { code: 'es', text: 'Spanish' },
        { code: 'fr', text: 'French' },
        //{ code: 'pt', text: 'Portugese' },
        { code: 'tr', text: 'Turkish' },
      ],
    };
  },
  methods: {
    onChange() {
      store.loadUserData();
      store.loadQuestionSections();
    },
  },
};
</script>

<style lang="scss">
.langSelect {
  position: fixed;
  right: 50px;
  top: 25px;
  z-index: 100;
  font-size: 10px;
  padding: 0px;
}

.langSelect select {
  -webkit-appearance: none;
  appearance: none;
  box-shadow: none !important;
  background-color: transparent;
  color: #fff;
  border: 0px;
  text-decoration: underline;
  outline: 0px;
}

.langSelect select option {
  color: #000;
  background-color: #fff;
  padding: 10px;
  margin: 10px;
  font-size: 12px;
  line-height: 20px;
  text-decoration: none;
  outline: 0px;
  border: 0px;
}
.langSelect select:focus::-ms-value {
  border: 0px !important;
  outline: 0px !important;
}
</style>
